import React, { useEffect, useState } from 'react';

import PopModal from 'Components/organisms/Modal/PopModal';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function PopModalComponent() {
  const [title, setTitle] = useState('타이틀입니다.');
  const [description, setDescription] = useState('설명입니다.');
  const [button, setButton] = useState('닫기');
  const [open, setOpen] = useState(false);
  return (
    <div className={cx('pop-modal')}>
      타이틀:{' '}
      <input
        placeholder="타이틀"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
      />
      <br />
      설명:{' '}
      <input
        placeholder="타이틀"
        value={description}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
      />
      <br />
      버튼 텍스트:{' '}
      <input
        placeholder="버튼 텍스트"
        value={button}
        onChange={(e) => {
          setButton(e.target.value);
        }}
      />
      <br />
      <button onClick={() => setOpen(true)}>팝업 띄우기</button>
      <PopModal
        open={open}
        title={title}
        description={description}
        renderDescription={() => {
          return (
            <div
              style={{
                padding: '17px',
                backgroundColor: '#f6f6f6',
                color: '#919191',
                borderRadius: '3px',
                wordBreak: 'keep-all',
              }}
            >
              랜더링을 이용한 커스텀 설명이 가능합니다.
            </div>
          );
        }}
        buttonText={button}
        buttonOnClick={() => setOpen(false)}
        onClose={() => setOpen(false)}
      >
        <div style={{ width: '70%', margin: '0 auto' }}>
          태그와 태그 사이에 html을 넣어 컴포넌트에서 <strong>{`{children}`} 노드</strong>로 추가가
          가능합니다.
        </div>
      </PopModal>
    </div>
  );
}

export default PopModalComponent;

export const path = '/pop_modal';
